<template>
  <div class="source-wrap" v-loading="loading">
    <el-button type="primary" size="small" @click="drawer = !drawer">{{$t('feed.settings.source.sourceButton')}}</el-button>
    <br><br>
    {{$t('feed.settings.source.title')}}
    <el-divider></el-divider>

    <ul class="source-list" v-if="sources.length">
      <li class="source-list__item" v-for="(source, index) in sources" :key="index">
        <div class="source-list__item-delete" @click="deleteSource(source.id)">
          <i class="el-icon-close"></i>
        </div>
        <div class="pseudo-link-wrap" @click="goToLink(source)">
          <el-avatar :src="source.image" size="large"></el-avatar>
        </div>
        <div class="network-name">
          <img src="../../../../../assets/img/vk-icon.svg" width="16px" v-if="source.network_name === 'vk'">
          <img src="../../../../../assets/img/ok-icon.svg" width="16px" v-if="source.network_name === 'ok'">
          <img src="../../../../../assets/img/yt.png" width="16px" v-if="source.network_name === 'yt'">
          <img src="../../../../../assets/img/twitter.svg" width="16px" v-if="source.network_name === 'tw'">
          <img src="../../../../../assets/img/telegram.svg" width="16px" v-if="source.network_name === 'tg'">
          <img src="../../../../../assets/img/facebook.svg" width="16px" v-if="source.network_name === 'fb'">
          <img src="../../../../../assets/img/gs.svg" width="16px" v-if="source.network_name === 'gs'">
        </div>
      </li>
    </ul>
    <ul class="source-list" v-else>
      <template v-if="isLoaded">
        <li>
          {{$t('feed.settings.source.empty')}}.
        </li>
      </template>
      <template v-else>
        <li class="source-list__item" v-for="item in limit" :key="item">
          <el-avatar  src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" size="large"></el-avatar>
        </li>
      </template>
    </ul>

    <el-drawer
      custom-class="source-drawer"
      :visible.sync="drawer"
      :direction="direction"
      size="100%"
      :append-to-body="true"
    >
      <new-source
        @updateSources="updateSources"
      />
    </el-drawer>
  </div>
</template>

<script>
  // api
  import { getSourcesApi, deleteSourcesApi } from "../../../../../api/feeds";

  // components
  import notify from "../../../../../helpers/notify";
  import NewSource from './components/NewSource';

  export default {
    name: 'Source',
    props: {
      active: {
        type: Boolean
      },
    },
    data() {
      return {
        isLoaded: false,
        loading: false,
        sources: [],
        offset: 0,
        start: 0,
        limit: 120,
        drawer: false,
        direction: 'rtl',
      };
    },
    methods: {
      goToLink(source) {
        window.open(source.url, '_blank');
      },
      deleteSource(source_id) {
        let username = this.sources.find(item => item.id === source_id).username;

        this.$alert(`Удалить источник ${username}?`, 'Удаление', {
          confirmButtonText: 'ДА',
          cancelButtonText: 'НЕТ',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.handleDelete(source_id);
            } else {
              this.$message({
                type: 'info',
                message: `удаление отменено`
              });
            }
          }
        });
      },
      handleDelete(source_id) {
        let params = {
          source_id
        };

        this.loading = true;

        deleteSourcesApi(params).then(() => {
          this.loading = false;
          this.sources = this.sources.filter(item => item.profile_id !== source_id);
          this.updateSources()
          notify.call(this, `Источник удален`, "success");
        });
        
      },
      updateSources(source) {
        /*this.sources.push({
          username: source.name,
          image: source.image,
          id: source.id,
          profile_id: source.profile_id
        });*/
        
        this.drawer = false;
        this.getSources()
      },
      getSources() {
        let params = {
          thread_id: this.$route.params.threadId,
          offset: this.offset,
          start: this.start,
          limit: this.limit,
          sources_only: true,
        };
        this.loading = true;
        getSourcesApi(params).then((resp) => {
          this.sources = [ ...resp.data.members];
          this.loading = false;
          this.isLoaded = true;
        });
      }
    },
    watch: {
      active(value) {
        if (value) {
          if (!this.sources.length) {
            this.getSources();
          }
        }
      }
    },
    components: {
      NewSource,
    },
  };
</script>

<style>
  .source-list {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .source-list__item {
    position: relative;
    padding: 15px;
    margin-bottom: 15px;
  }
  .source-list__item-delete {
    right: 9px;
    top:9px;
    position: absolute;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 50%;
  }
  .network-name {
    position: absolute;
    bottom: 9px;
    left: 9px;
  }
  .pseudo-link-wrap {
    cursor: pointer;
  }
</style>
